import { useQuery } from '@tanstack/react-query'
import { settingsApi, type GeneralSettings } from '@/lib/api/misc'

export function useGeneralSettings() {
  return useQuery<GeneralSettings>({
    queryKey: ['general-settings'],
    queryFn: async () => {
      const res = await settingsApi.get()
      return res.data as GeneralSettings
    },
    staleTime: 60_000,
  })
}

export function usePrintMethod(): 'agent' | 'browser' {
  const { data } = useGeneralSettings()
  return data?.print_method === 'browser' ? 'browser' : 'agent'
}
